import _ from 'lodash';
import { dashify } from '@wix/wix-vod-shared/dist/src/common/utils/guid';
import { VIDEO_APP_DEF_ID } from '@wix/wix-vod-constants/dist/common/app-def-id';
import { addResources, createPlanBenefits, deleteResources, list, update, deletePlanBenefits, } from '@wix/ambassador-pricing-plans-v2-benefit/http';
import { BenefitType, } from '@wix/ambassador-pricing-plans-v2-benefit/types';
import { getEligibleOrders } from '@wix/ambassador-pricing-plans-v2-member-benefit/http';
import { getPlan } from '@wix/ambassador-pricing-plans-v2-plan/http';
export class PricingPlansAPI {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    configBenefit(resourceIds, benefitId) {
        const id = benefitId ? { id: benefitId } : {};
        return Object.assign({ benefitType: BenefitType.UNLIMITED, resourceIds }, id);
    }
    async connectChannelToPlan(planId, channelId) {
        const { benefit } = await this.getBenefitWithPlanInfo(planId);
        const resourceId = dashify(channelId);
        if (benefit) {
            const benefitId = benefit === null || benefit === void 0 ? void 0 : benefit.id;
            await this.httpClient.request(addResources({
                resources: [
                    {
                        planId,
                        benefitId,
                        resourceId,
                    },
                ],
            }));
        }
        else {
            await this.createPlanBenefit(planId, [resourceId]);
        }
    }
    async createPlanBenefit(planId, resourceIds) {
        await this.httpClient.request(createPlanBenefits({
            planId,
            appDefId: VIDEO_APP_DEF_ID,
            benefits: [this.configBenefit(resourceIds, null)],
        }));
    }
    async disconnectChannelFromPlan(planId, channelId) {
        const { benefit } = await this.getBenefitWithPlanInfo(planId);
        const benefitId = benefit === null || benefit === void 0 ? void 0 : benefit.id;
        const resourceId = dashify(channelId);
        await this.httpClient.request(deleteResources({
            linkedResources: {
                benefitId,
                planId,
                resourceIds: [resourceId],
            },
        }));
    }
    async getBenefits() {
        const { data: { benefitsWithPlanInfo }, } = await this.httpClient.request(list({
            appDefIds: [VIDEO_APP_DEF_ID],
        }));
        return benefitsWithPlanInfo || [];
    }
    async getBenefitWithPlanInfo(planId) {
        const { data: { benefitsWithPlanInfo }, } = await this.httpClient.request(list({
            appDefIds: [VIDEO_APP_DEF_ID],
            planIds: [planId],
        }));
        return benefitsWithPlanInfo && benefitsWithPlanInfo.length
            ? benefitsWithPlanInfo[0]
            : {};
    }
    async getConnectedPlansIds(channelId) {
        const plans = await this.getConnectedPlans(channelId);
        return plans.map(({ id }) => id);
    }
    async getConnectedPlans(channelId) {
        const resourceId = dashify(channelId);
        const { data: { benefitsWithPlanInfo }, } = await this.httpClient.request(list({
            appDefIds: [VIDEO_APP_DEF_ID],
            resourceIds: [resourceId],
        }));
        const plans = _.map(benefitsWithPlanInfo, ({ planInfo }) => planInfo);
        return _.uniqBy(plans, 'id');
    }
    async getPlan(planId) {
        const { data: { plan }, } = await this.httpClient.request(getPlan({
            id: planId,
        }));
        return plan;
    }
    async overwritePlanChannels(planId, channelIds) {
        const { benefit } = await this.getBenefitWithPlanInfo(planId);
        if (benefit) {
            await this.httpClient.request(update({
                planId,
                appDefId: VIDEO_APP_DEF_ID,
                benefits: [this.configBenefit(channelIds, benefit.id)],
            }));
        }
        else {
            await this.createPlanBenefit(planId, channelIds);
        }
    }
    async removeChannelFromAllPlans(channelId) {
        const resourceId = dashify(channelId);
        await this.httpClient.request(deleteResources({
            resourceIds: {
                resourceIds: [resourceId],
            },
        }));
    }
    async removePlanBenefit(planId) {
        const { benefit } = await this.getBenefitWithPlanInfo(planId);
        if (benefit) {
            await this.httpClient.request(deletePlanBenefits({
                planId,
                benefitIds: [benefit.id],
            }));
        }
    }
    async hasAccessToChannel(channelId, contactId) {
        const { data: { memberOrdersByPlan }, } = await this.httpClient.request(getEligibleOrders({
            contactId,
            resourceId: channelId,
            appDefId: VIDEO_APP_DEF_ID,
            targetDate: new Date(),
        }));
        return Boolean(memberOrdersByPlan === null || memberOrdersByPlan === void 0 ? void 0 : memberOrdersByPlan.length);
    }
}
//# sourceMappingURL=pricing-plans-api.js.map